import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    padding: '2px 0px 24px',
    color: 'var(--powered-by-text-color)',
    fontSize: 11,
    fontWeight: 'normal',
    lineHeight: '16px',
    textTransform: 'inherit',
    background: 'var(--text-primary-light)',
    backdropFilter: 'blur(3px)',
  },
}));

export const FooterMessage: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      Copilot could make mistakes. Room owner may review the chat to verify
      accuracy.
    </div>
  );
};
